import React, { useContext, useState } from 'react';
import './CSS/ShopCategory.css';
import { ShopContext } from '../Context/ShopContext';
import dropdown_icon from '../Components/Assets/Frontend_Assets/dropdown_icon.png';
import Item from '../Components/Item/Item';

const ShopCategory = ({ banner, category }) => {
    const { all_product } = useContext(ShopContext);

    const [sortType, setSortType] = useState('default');

    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 6;

    let filteredProducts = all_product.filter(item => item.category === category);

    if (sortType === 'low') {
        filteredProducts.sort((a, b) => a.new_price - b.new_price);
    } else if (sortType === 'high') {
        filteredProducts.sort((a, b) => b.new_price - a.new_price);
    }

    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

    const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="shop-category">
            <img src={banner} alt={`${category} banner`} className="shopcategory-banner" />

            <div className="shopcategory-indexSort">
                <p>
                    <span>Showing {indexOfFirstProduct + 1}-{Math.min(indexOfLastProduct, filteredProducts.length)}</span>{' '}
                    out of {filteredProducts.length} products
                </p>

                <div className="shopcategory-sort">
                    <select
                        value={sortType}
                        onChange={(e) => {
                            setSortType(e.target.value);
                            setCurrentPage(1);
                        }}
                    >
                        <option value="default">Sort by</option>
                        <option value="low">Price: Low to High</option>
                        <option value="high">Price: High to Low</option>
                    </select>
                    <img src={dropdown_icon} alt="dropdown" />
                </div>
            </div>

            <div className="shopcategory-products">
                {currentProducts.length > 0 ? (
                    currentProducts.map((item) => (
                        <Item
                            key={item.id}
                            id={item.id}
                            name={item.name}
                            image={item.image}
                            new_price={item.new_price}
                            old_price={item.old_price}
                        />
                    ))
                ) : (
                    <p className="no-products">لا توجد منتجات في هذا القسم حاليًا.</p>
                )}
            </div>

            {totalPages > 1 && (
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
                        <button
                            key={number}
                            onClick={() => paginate(number)}
                            className={currentPage === number ? 'active' : ''}
                        >
                            {number}
                        </button>
                    ))}

                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default ShopCategory;